import {css} from '@emotion/css';
import {colours, spacing} from '@fo/shared/styles/variables';

export default {
  componentWrapper: css`
    label: navigationSectionMobile__componentWrapper;
    display: flex;
    flex-direction: column;
    padding: ${spacing.XS};
    width: 100%;
    border-bottom: 1px solid ${colours.border.SEPARATOR_OFF_WHITE};
  `,
  columns: css`
    label: navigationSectionMobile__columns;
  `,
  dialogueContentsOverride: css`
    width: 100%;
  `,
};
